function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { WhiteboardKeys } from './WhiteboardKeys';
export class LiveCursor {
  constructor(canvasElement, paperScope, userManager, requestUserMap) {
    _defineProperty(this, "container", document.createElement('div'));
    _defineProperty(this, "showLiveCursor", true);
    _defineProperty(this, "userManager", void 0);
    _defineProperty(this, "requestUserMap", void 0);
    _defineProperty(this, "cursors", new Map());
    _defineProperty(this, "paperScope", void 0);
    _defineProperty(this, "resizeobserver", void 0);
    _defineProperty(this, "timeoutIdMap", new Map());
    _defineProperty(this, "lastVisibleChangeTimes", new Map());
    this.userManager = userManager;
    this.paperScope = paperScope;
    this.requestUserMap = requestUserMap;
    this.container.setAttribute('data-forge-cursors', '');
    this.container.style.cssText = 'overflow:hidden;pointer-events:none;z-index:999;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);';
    this.container.style.pointerEvents = 'none';
    this.resizeobserver = new ResizeObserver(() => {
      const bounds = canvasElement.getBoundingClientRect();
      this.container.style.width = bounds.width + 'px';
      this.container.style.height = bounds.height + 'px';
    });
    this.resizeobserver.observe(canvasElement);
  }
  createCursor(userId) {
    const cursor = document.createElement('fcursor');
    cursor.setAttribute('data-forge-cursor', userId);
    cursor.style.backgroundColor = this.requestUserMap(userId).get(WhiteboardKeys.themeColor);
    cursor.style.color = '#fff';
    cursor.style.position = 'absolute';
    cursor.style.whiteSpace = 'nowrap';
    cursor.style.display = 'block';
    cursor.style.fontSize = '12px';
    cursor.style.padding = '2px 4px';
    cursor.style.borderRadius = '4px';
    this.updateCursorLabel(userId, cursor);
    return cursor;
  }
  updateCursorLabel(userId, cursor) {
    const target = cursor ?? this.cursors.get(userId);
    if (!target) {
      return;
    }
    if (target.textContent && target.textContent !== userId) {
      return;
    }
    target.textContent = this.userManager.getUser(userId)?.nickName ?? userId;
  }
  isOnSamePage(userId) {
    const otherPage = this.requestUserMap(userId).get(WhiteboardKeys.currentPage);
    const selfPage = this.requestUserMap(this.userManager.selfId).get(WhiteboardKeys.currentPage);
    if (otherPage !== selfPage) {
      return false;
    }
    return true;
  }
  detectEnable(userId) {
    if (!this.showLiveCursor) {
      const cursor = this.cursors.get(userId);
      if (cursor) {
        cursor.style.display = 'none';
      }
    }
    return this.showLiveCursor;
  }
  updateCursorPosition(point, userId) {
    if (!this.isOnSamePage(userId) || userId === this.userManager.selfId) {
      return;
    }
    if (!this.detectEnable(userId)) {
      return;
    }
    const lastVisibleChangeTime = this.lastVisibleChangeTimes.get(userId);
    if (lastVisibleChangeTime && Date.now() - lastVisibleChangeTime < 100) {
      return;
    }
    if (!this.cursors.has(userId)) {
      const cursor = this.createCursor(userId);
      this.cursors.set(userId, cursor);
      this.container.appendChild(cursor);
    }
    const cursor = this.cursors.get(userId);
    if (cursor) {
      this.updateCursorLabel(userId, cursor);
      const viewPoint = this.paperScope.project.view.projectToView(point);
      cursor.style.left = viewPoint.x + 'px';
      cursor.style.top = viewPoint.y + 'px';
      cursor.style.display = 'block';
    }
    if (this.timeoutIdMap.has(userId)) {
      clearTimeout(this.timeoutIdMap.get(userId));
    }
    this.timeoutIdMap.set(userId, setTimeout(() => {
      const cursor = this.cursors.get(userId);
      if (cursor) {
        cursor.style.display = 'none';
      }
    }, 5000));
  }
  updateCursorVisible(visible, userId) {
    if (!this.isOnSamePage(userId) || userId === this.userManager.selfId) {
      return;
    }
    if (!this.detectEnable(userId)) {
      return;
    }
    this.lastVisibleChangeTimes.set(userId, Date.now());
    const cursor = this.cursors.get(userId);
    if (cursor) {
      cursor.style.display = visible ? 'block' : 'none';
    }
  }
}